import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Download, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const isInstalled =
  window.matchMedia('(display-mode: standalone)').matches ||
  (navigator as unknown as { standalone?: boolean }).standalone === true

function shouldShow(): boolean {
  if (isInstalled) return false
  if (localStorage.getItem('installBannerDismissed') === 'true') return false
  const count = parseInt(localStorage.getItem('loginCount') ?? '0', 10)
  return count >= 3
}

export function InstallBanner() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [visible, setVisible] = useState(() => shouldShow())

  if (!visible) return null

  function dismiss() {
    localStorage.setItem('installBannerDismissed', 'true')
    setVisible(false)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 14px',
        background: 'color-mix(in srgb, var(--brand) 10%, var(--surface))',
        borderBottom: '1px solid color-mix(in srgb, var(--brand) 20%, var(--border))',
      }}
    >
      <Download size={16} color="var(--brand)" strokeWidth={2} style={{ flexShrink: 0 }} />

      <span
        style={{
          flex: 1,
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-sm)',
          color: 'var(--text-body)',
          minWidth: 0,
        }}
      >
        {t('settings.install_banner_text')}
      </span>

      <button
        type="button"
        onClick={() => navigate('/how-to-install')}
        style={{
          border: 'none',
          background: 'none',
          padding: 0,
          cursor: 'pointer',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-sm)',
          fontWeight: 600,
          color: 'var(--brand)',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {t('settings.install_banner_link')} →
      </button>

      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          border: 'none',
          background: 'none',
          padding: 4,
          cursor: 'pointer',
          color: 'var(--text-muted)',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          borderRadius: 'var(--radius-sm)',
        }}
      >
        <X size={16} strokeWidth={2} />
      </button>
    </div>
  )
}
